import { DataModelBuilder, SerializationContext, SerializedData, DataModel } from '../../../../dto/data-model.js';
import { MapUtils } from '../../../../../utility/map-utils.js';
import { toEnumFromString } from '../../../../../serialization/enum-utils.js';
import { DiscountCodeBase } from '../../../../../contracts/discount-code.js';
import { cloneDataOrNull, isSameData } from '../../../../dto/data-model-utils.js';

export enum CartDiscountType {
  Fixed = 'Fixed',
  Percentage = 'Percentage',
  DownTo = 'DownTo',
  Voucher = 'Voucher',
}

export class CartDiscountDto extends DataModel {
  static readonly TYPE_ID = '63a2112924854ce9a350fb8859f21c40';

  private constructor(
    public readonly type: CartDiscountType,
    public readonly amount: string | null,
    public readonly code: string | null,
    public readonly voucher: DiscountCodeBase | null,
  ) {
    super();
  }

  get $typeId(): string {
    return CartDiscountDto.TYPE_ID;
  }

  static create(args: {
    type: CartDiscountType;
    amount: string | null;
    code: string | null;
    voucher: DiscountCodeBase | null;
  }): CartDiscountDto {
    return new CartDiscountDto(args.type, args.amount, args.code, args.voucher);
  }

  static fromMap(context: SerializationContext, map: SerializedData): CartDiscountDto {
    return CartDiscountDto.create({
      type: toEnumFromString(MapUtils.getString(map, 'type'), CartDiscountType),
      amount: MapUtils.getStringOrNull(map, 'amount'),
      code: MapUtils.getStringOrNull(map, 'code'),
      voucher: context.fromDataOrNull<DiscountCodeBase>(MapUtils.getRecordOrNull(map, 'voucher')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'type': this.type,
      'amount': this.amount,
      'code': this.code,
      'voucher': context.toDataOrNull(this.voucher),
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    type = this.type,
    amount = this.amount,
    code = this.code,
    voucher = cloneDataOrNull(this.voucher),
  }: {
    type?: CartDiscountType;
    amount?: string | null;
    code?: string | null;
    voucher?: DiscountCodeBase | null;
  } = {}): this {
    return CartDiscountDto.create({ type, amount, code, voucher }) as this;
  }

  isSame(other: CartDiscountDto): boolean {
    return this === other || (
      this.type === other.type &&
      this.amount === other.amount &&
      this.code === other.code &&
      isSameData(this.voucher, other.voucher)
    );
  }
}

export class CartDiscountDtoBuilder extends DataModelBuilder<CartDiscountDto> {
  build(context: SerializationContext, map: SerializedData): CartDiscountDto {
    return CartDiscountDto.fromMap(context, map);
  }
}
